import React from 'react';

const BehavioralPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-emerald-400 to-cyan-500 rounded-2xl mb-6">
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">Coming Soon</h2>
        <p className="text-gray-400 max-w-md">
          We're working on bringing you the best behavioral interview preparation experience. 
          Stay tuned for expert-curated questions and answers to help you ace your interviews.
        </p>
      </div>
    </div>
  );
};

export default BehavioralPage;